import $ from 'jquery'

$(function () {
	// Move alert bar if admin bar is present
	if ($('#wpadminbar').length > 0) {
		if ($('.site-alert-bar')) {
			//$('.site-alert-bar').css('top', '32px')
		} else {
			//$('.site-navigation').css('padding', '20px 0')
		}
	}
})
